import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Hero from "./components/Hero";
import About from "./components/About";
import Features from "./components/Features";
import Testimonials from "./components/Testimonials";
import DownloadCTA from "./components/DownloadCTA";
import CommentsList from "./components/CommentsList";
import CommentForm from "./components/CommentForm";
import TermsOfUse from "./components/TermsOfUse";
import PrivacyPolicy from "./components/PrivacyPolicy";
import SocialMedia from "./components/SocialMedia";

import { LanguageProvider, useLanguage } from "./contexts/LanguageContext";

// Home page component
function HomePage() {
    const [refreshComments, setRefreshComments] = useState(0);

    const handleCommentAdded = () => {
        setRefreshComments(prev => prev + 1);
    };

    return (
        <>
            <Hero />
            <About />
            <Features />
            {/* <Testimonials /> */}
            
            {/* Comments Section */}
            <section id="comments" className="py-16 md:py-20 bg-gradient-to-br from-orange-50/30 to-gray-100">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <CommentsList refreshTrigger={refreshComments} />
                </div>
            </section>
            
            {/* Comment Form Section */}
            <section className="py-16 md:py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <CommentForm onCommentAdded={handleCommentAdded} />
                </div>
            </section>
            
            <DownloadCTA />
        </>
    );
}

// App content wrapper that uses language context
const AppContent = () => {
    const { isRTL } = useLanguage();

    useEffect(() => {
        // Set document direction based on language
        document.dir = isRTL() ? 'rtl' : 'ltr';
        document.documentElement.dir = isRTL() ? 'rtl' : 'ltr';
    }, [isRTL]);

    return (
        <Router>
            <div className={`font-sans ${isRTL() ? 'rtl' : 'ltr'}`}>
                <Layout>
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/terms-of-use" element={<TermsOfUse />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        <Route path="/sm" element={<SocialMedia />} />
                    </Routes>
                </Layout>
            </div>
        </Router>
    );
};

function App() {
    return (
        <LanguageProvider>
            <AppContent />
        </LanguageProvider>
    );
}

export default App;
